export const route = { patterns: { dashboard: '/dashboard' } };
